import APICaller from '../library/APICaller'

const ServiceRequestServices = {
  /**
   * selectServicerequestList
   * @return {Promise}
   */
  getServiceRequests ({ empNo, startDate, endDate, customerDepts, filters }) {
    return APICaller.post('/api/v1/servicereqeusts/',{ empNo, startDate, endDate, customerDepts, filters })
  },
  getServiceRequestTotalChartData({ empNo, startDate, endDate, customerDepts }){
    return APICaller.post('/api/v1/servicereqeusts/total-chart',{ empNo, startDate, endDate, customerDepts })
  },
  getServiceRequestTopFiveChartData({ empNo, startDate, endDate, customerDepts }){
    return APICaller.post('/api/v1/servicereqeusts/topfive-chart',{ empNo, startDate, endDate, customerDepts })
  },
  getServiceRequest(id){
    return APICaller.get(`/api/v1/servicereqeusts/${id}`, {id})
  },
  getServiceRequestStatusCombo(){
    return APICaller.get(`/api/v1/servicereqeusts/status-combo`)
  }
  /**
   * selectServiceRequest
   * @param  {String} id id
   * @return {Promise}
   */


}

export default ServiceRequestServices


// WEBPACK FOOTER //
// ./src/services/ServiceRequestServices.js